import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useEffect, useState } from 'react'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignCreateModal = ({ isOpen, isSubmitting, onClose, onCreate }) => {
  const [templateName, setTemplateName] = useState('')

  useEffect(() => {
    if (isOpen) {
      setTemplateName('')
    }
  }, [isOpen])

  if (!isOpen) {
    return null
  }

  const trimmedName = templateName.trim()
  const isDisabled = !trimmedName || isSubmitting

  return (
    <ConfirmationDialog
      title="Create email design"
      positiveMessage="Create and edit"
      negativeMessage="Cancel"
      actLikeForm
      isButtonDisabled={isDisabled}
      onClose={onClose}
      onConfirm={() => onCreate(trimmedName)}
      onPressEnter={() => {
        if (!isDisabled) {
          onCreate(trimmedName)
        }
      }}
      maxWidth={440}
    >
      <p className={styles.createModalIntro}>
        Name your layout, then customize header, hero, and footer in the editor.
        Campaign message text stays on each invite campaign.
      </p>
      <TextInput
        label="Template name"
        value={templateName}
        onChangeValue={setTemplateName}
        autoFocus
        placeholder="e.g. Summer promo layout"
      />
      <div className={styles.createModalHint}>
        Apply the design to campaigns from Manage Campaigns → Email Template Configuration after saving.
      </div>
    </ConfirmationDialog>
  )
}

export default InviteEmailDesignCreateModal
